module.exports = __webpack_public_path__ + "media/boschautoparts/favicon-e39d72eb.png";